/* eslint-disable no-useless-constructor */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ColorLogo from '../../images/color-logo.webp';
import { ReactComponent as Burger } from '../../images/burger-r.svg';
import {
  ABOUT_US,
  CONTACTS,
  BLOG,
  CONTACTS_US,
  LOG_IN,
  HELP,
} from '../../Utils/Constants/HeaderConstats';
import {
  PHONE_NUMBER,
  PHONE_NUM_CALL,
} from '../../Utils/Constants/GlobalConstants';
import './css/Header.css';
import {
  getAccessTokenExpiration,
  clearUserSession,
} from '../../Utils/CommonUtils';
import {
  changeLoginModalVisibility,
  changeHelpModalVisibility,
} from '../../DataStore/actions/modalWindowActions';
import {
  changeContactModalVisible,
  changeUserFirstLetter,
  changeUserAuthStatus,
} from '../../DataStore/actions/searchFormActions';
import UserMenuFunc from './UserMenu/UserMenuFunc';
import BurgerMenuFunc from './BurgerMenu/BurgerMenuFunc';

const mapStateToProps = (state) => ({ ...state });

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.burgerNode = React.createRef();

    this.state = {
      isUserMenuVisible: false,
      isMunuVisible: false,
    };
  }

  componentDidMount() {
    const {
      isUserLoggedIn,
      userFirstLetter,
      changeUserFirstLetter: changeUserFirstLetterAction,
    } = this.props;

    if (!isUserLoggedIn) {
      // drop leftovers of an expired session
      clearUserSession();
      return;
    }

    if (userFirstLetter.length === 0) {
      const email = window.localStorage.getItem('email');

      if (email && email.length > 0) {
        const letter = email.charAt(0).toUpperCase();
        changeUserFirstLetterAction(letter);
      }
    }

    this.scheduleSessionExpiration();
  }

  componentDidUpdate(prevProps) {
    const { isUserLoggedIn } = this.props;

    if (prevProps.isUserLoggedIn !== isUserLoggedIn) {
      this.scheduleSessionExpiration();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.sessionTimeout);
  }

  scheduleSessionExpiration = () => {
    const { isUserLoggedIn } = this.props;
    clearTimeout(this.sessionTimeout);

    if (isUserLoggedIn) {
      const delay = getAccessTokenExpiration() - Date.now();
      this.sessionTimeout = setTimeout(
        this.handleSessionExpired,
        Math.max(delay, 0),
      );
    }
  };

  handleSessionExpired = () => {
    const { changeUserAuthStatus: changeUserAuthStatusAction } = this.props;
    document.removeEventListener('click', this.handleUserOutsideClick, false);
    this.setState(() => ({ isUserMenuVisible: false }));
    clearUserSession();
    changeUserAuthStatusAction(false);
  };

  handleUserClick = () => {
    const { isUserMenuVisible } = this.state;
    if (!isUserMenuVisible) {
      document.addEventListener('click', this.handleUserOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleUserOutsideClick, false);
    }

    this.setState(() => ({
      isUserMenuVisible: !isUserMenuVisible,
    }));
  };

  handleUserOutsideClick = (e) => {
    if (
      e.target.className === 'h_user_button' ||
      e.target.className === 'user_menu_link'
    ) {
      return;
    }

    this.handleUserClick();
  };

  handleMenuClick = () => {
    const { isMunuVisible } = this.state;
    if (!isMunuVisible) {
      document.addEventListener('click', this.handleMunuOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleMunuOutsideClick, false);
    }

    this.setState(() => ({
      isMunuVisible: !isMunuVisible,
    }));
  };

  handleMunuOutsideClick = (e) => {
    const elementClasses = e.target.getAttribute('class');
    const isIconCLick = e.target.getAttribute('fill') !== null;

    if (
      elementClasses === 'h_menu_link br_text_16' ||
      elementClasses === 'burger_phone_w' ||
      elementClasses === 'br_text_16' ||
      elementClasses === 'br_text_16 burger_contact'
    ) {
      this.handleMenuClick();
    }

    if (
      (this.burgerNode && this.burgerNode.current.contains(e.target)) ||
      elementClasses === 'h_burger_but' ||
      isIconCLick
    ) {
      return;
    }

    this.handleMenuClick();
  };

  handleContanctUsModal = () => {
    const { changeContactModalVisible: changeContactModalVisibleAction } =
      this.props;

    changeContactModalVisibleAction(true);
  };

  helpModalClick = () => {
    const { changeHelpModalVisibility: changeHelpModalVisibilityAction } =
      this.props;

    changeHelpModalVisibilityAction(true);
  };

  render() {
    const { isUserMenuVisible, isMunuVisible } = this.state;
    const {
      isUserLoggedIn,
      changeLoginModalVisibility: changeLoginModalVisibilityAction,
      userFirstLetter,
    } = this.props;

    return (
      <div className="h_header_container">
        <div className="containerW">
          <div className="h_header_w">
            <div className="h_left_w">
              <Link to="/">
                <img className="h_logo" src={ColorLogo} alt="" />
              </Link>
              <div className="h_menu_w">
                <Link to="/about/" className="h_menu_link br_text_16">
                  {ABOUT_US}
                </Link>
                <Link to="/contacts/" className="h_menu_link br_text_16">
                  {CONTACTS}
                </Link>
                <Link
                  to="/blog/"
                  target="_blank"
                  className="h_menu_link br_text_16"
                >
                  {BLOG}
                </Link>
              </div>
            </div>

            <div className="h_center_w">
              <button
                type="button"
                className="h_help_button wr_text_15 bg_trans_05"
                onClick={this.helpModalClick}
              >
                {HELP}
              </button>
            </div>

            <div className="h_right_w">
              <div className="h_right_links">
                <a
                  href={`tel:${PHONE_NUM_CALL}`}
                  className="bm_text_18 h_phone"
                >
                  {PHONE_NUMBER}
                </a>
                <button
                  type="button"
                  className="br_text_18 h_contact"
                  onClick={this.handleContanctUsModal}
                >
                  {CONTACTS_US}
                </button>
              </div>
              {isUserLoggedIn ? (
                <div className="h_user_menu_w">
                  <button
                    type="button"
                    onClick={this.handleUserClick}
                    className="h_user_button"
                  >
                    {userFirstLetter}
                  </button>
                  {isUserMenuVisible && (
                    <div className="h_user_menu">
                      <UserMenuFunc />
                    </div>
                  )}
                </div>
              ) : (
                <button
                  type="button"
                  className="dbr_text_16 h_login"
                  onClick={() => changeLoginModalVisibilityAction(true)}
                >
                  <div className="h_login_content">{LOG_IN}</div>
                </button>
              )}

              <div className="h_burger">
                <button
                  type="button"
                  className="h_burger_but"
                  onClick={this.handleMenuClick}
                >
                  <Burger />
                </button>
                {isMunuVisible && (
                  <div className="h_burger_popup">
                    <div ref={this.burgerNode}>
                      <BurgerMenuFunc />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  changeLoginModalVisibility: PropTypes.func.isRequired,
  changeContactModalVisible: PropTypes.func.isRequired,
  changeHelpModalVisibility: PropTypes.func.isRequired,
  changeUserFirstLetter: PropTypes.func.isRequired,
  changeUserAuthStatus: PropTypes.func.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  userFirstLetter: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, {
  changeLoginModalVisibility,
  changeContactModalVisible,
  changeHelpModalVisibility,
  changeUserFirstLetter,
  changeUserAuthStatus,
})(Header);
